import React from "react";

export default function NotFound() {
  return (
    <div className="not-found">
      <h2>404 - لم يتم العثور على ما تم طلبه</h2>
    </div>
  );
}
